// extracted by mini-css-extract-plugin
export var markdown = "_sf-0";
export var tableWrapper = "_sf-1";